import MessageConfigurationContainer from './MessageConfigurationContainer';
import MessageConfigurationHelp from './MessageConfigurationHelp';

export { MessageConfigurationHelp };
export default MessageConfigurationContainer;
